import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Quote, Building2, GraduationCap, Hotel, ShoppingBag, BarChart3 } from 'lucide-react';
import SEO from '../components/SEO';
import './Clients.css';

import religareLogo from '../assets/clients/religare.png';
import iwpLogo from '../assets/clients/iwp-academy.png';
import maashitlaLogo from '../assets/clients/maashitla.png';
import greenLandLogo from '../assets/clients/green-land-model-school.jpeg';
import sportsUniversityLogo from '../assets/clients/suoh.png';
import indusLogo from '../assets/clients/indus.jpeg';
import skiLogo from '../assets/clients/ski.png';
import mindexLogo from '../assets/clients/mindex.jpeg';
import sigmaLogo from '../assets/clients/sigma.png';
import ntsLogo from '../assets/clients/nts.jpeg';
import siwatchLogo from '../assets/clients/siwatch.jpeg';
import abhipraLogo from '../assets/clients/abhipra.jpeg';


const CLIENT_LOGOS = [
  { name: 'Religare & Associates', sector: 'Finance', logo: religareLogo },
  { name: 'IWP Academy', sector: 'Education', logo: iwpLogo },
  { name: 'Maashitla', sector: 'Enterprise', logo: maashitlaLogo },
  { name: 'Green Land Model School', sector: 'Education', logo: greenLandLogo },
  // { name: 'Valorelle', sector: 'Hospitality', logo: valorelleLogo },
  { name: 'Sports University of Haryana', sector: 'Education', logo: sportsUniversityLogo },
  { name: 'SKI', sector: 'Finance', logo: skiLogo },
  // { name: 'Sparepedia', sector: 'Retail', logo: sparepediaLogo },
  { name: 'Indus', sector: 'Hospitality', logo: indusLogo },
  { name: 'Mindex', sector: 'Finance', logo: mindexLogo },
  { name: 'Sigma', sector: 'Retail', logo: sigmaLogo },
  { name: 'NTS', sector: 'Retail', logo: ntsLogo },
  { name: 'Siwatch', sector: 'Retail', logo: siwatchLogo },
  { name: 'Abhipra', sector: 'Retail', logo: abhipraLogo },
];

const CASE_STUDIES = [
  {
    icon: <BarChart3 size={26} />,
    client: 'Religare & Associates',
    sector: 'Financial Services',
    result: '99.99% transaction accuracy',
    quote: 'SHIVKMS\'s RTA platform automated our compliance reporting completely. What used to take our team three days now happens in real time.',
    person: 'Finance Operations Lead',
  },
  {
    icon: <GraduationCap size={26} />,
    client: 'IWP Academy',
    sector: 'Education',
    result: '60% less admin workload',
    quote: 'Parent engagement has doubled since launch. The mobile app keeps everyone connected without burdening our front office staff.',
    person: 'Principal',
  },
  {
    icon: <Hotel size={26} />,
    client: 'Indus Hotels',
    sector: 'Hospitality',
    result: 'Real-time occupancy data',
    quote: 'Our front desk, housekeeping and finance teams finally work off the same numbers. Night audit now takes minutes, not hours.',
    person: 'General Manager',
  },
];

const STATS = [
  { value: '50+', label: 'Active Clients' },
  { value: '6', label: 'Industries Served' },
  { value: '27+', label: 'Years in Business' },
  { value: '99.9%', label: 'Client Retention' },
];

export default function Clients() {
  return (
    <div className="clients-page">
      <SEO
        title="Our Clients — Trusted Across Finance, Education & Hospitality"
        description="See the businesses that trust SHIVKMS: Religare, IWP Academy, Indus Hotels, Sparepedia, and 50+ more across finance, education, hospitality, and retail."
        keywords="SHIVKMS clients, software case studies, RTA software clients, school ERP clients India"
        path="/clients"
      />

      {/* Hero */}
      <section className="clients-hero">
        <div className="clients-hero-bg" />
        <div className="container">
          <div className="clients-hero-inner">
            <span className="eyebrow">Our Clients</span>
            <h1>Businesses That <span className="gradient-text">Trust SHIVKMS</span></h1>
            <p>From financial institutions to schools to hotel chains — see who relies on us to run critical operations every day.</p>
          </div>
        </div>
      </section>

      {/* Stats strip */}
      <section className="clients-stats-section">
        <div className="container">
          <div className="clients-stats-grid">
            {STATS.map((s, i) => (
              <div key={i} className="cstat">
                <span className="cstat-value">{s.value}</span>
                <span className="cstat-label">{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Client Grid */}
      <section className="section-py">
        <div className="container">
          <div className="section-heading">
            <span className="eyebrow">Our Portfolio</span>
            <h2>Trusted by <span className="gradient-text">Innovative Teams</span></h2>
            <div className="divider" />
          </div>
          <div className="client-logo-grid">
            {CLIENT_LOGOS.map((c, i) => (
             <div key={i} className="client-logo-card">
  <div className="clc-logo-wrap">
    <img
      src={c.logo}
      alt={`${c.name} logo`}
      className="clc-logo"
      loading="lazy"
    />
  </div>

  {/* <div className="clc-info">
    <span className="clc-sector">{c.sector}</span>
    <span className="clc-name">{c.name}</span>
  </div> */}
</div>
            ))}
          </div>
        </div>
      </section>

      {/* Case Studies */}
      <section className="section-py case-studies-section">
        <div className="cs-bg" />
        <div className="container">
          <div className="section-heading">
            <span className="eyebrow">Case Studies</span>
            <h2>Real Results, <span className="gradient-text">Real Businesses</span></h2>
            <div className="divider" />
          </div>
          <div className="case-studies-grid">
            {CASE_STUDIES.map((cs, i) => (
              <div key={i} className="case-study-card card">
                <div className="cs-icon">{cs.icon}</div>
                <span className="cs-sector">{cs.sector}</span>
                <h3 className="cs-client">{cs.client}</h3>
                <div className="cs-result">{cs.result}</div>
                <Quote size={22} className="cs-quote-icon" />
                <p className="cs-quote">{cs.quote}</p>
                <span className="cs-person">— {cs.person}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="clients-cta">
        <div className="clients-cta-bg" />
        <div className="container" style={{ textAlign: 'center', position: 'relative', zIndex: 1 }}>
          <h2>Become our next success story</h2>
          <p style={{ color: 'var(--text-secondary)', margin: '12px auto 32px', maxWidth: '480px', fontSize: '1.05rem' }}>
            Join 50+ businesses who trust SHIVKMS to run their mission-critical operations.
          </p>
          <Link to="/contact" className="btn-primary">
            Start Your Project <ArrowRight size={18} />
          </Link>
        </div>
      </section>
    </div>
  );
}
